import { render, staticRenderFns } from "./OpenProject.vue?vue&type=template&id=267fdaa2&"
import script from "./OpenProject.vue?vue&type=script&lang=js&"
export * from "./OpenProject.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports